import $ from 'jquery';
import slick from 'slick-carousel';

class Recipes {
	constructor() {
		this.$recipes = $('.recipes__slides');
		this.$sharing = $('.recipes__sharing').find('.sharing__list');
		this.url = '/data/recipes.json';
		this.content = [];
	}

	init() {
		this.getData();
		this.bindEvents();
	}

	bindEvents() {
		this.$recipes.on('beforeChange', this.handleChangeSlide);
	}

	handleChangeSlide = (e, slick, currentSlide, nextSlide) => {
		this.$sharing.attr({
			'data-title': this.content[nextSlide].title,
			'data-url': `https://horrorfood.woman.ru/share_recipe/${nextSlide + 1}/`
		});
	}

	fetchDataByUrl = async (url) => {
		try {
			const response = await window.fetch(url);
			if (response.ok) {
				const json = await response.json();
				return json;
			}
		}catch (e) {
			console.error('Error in fetch', e);
		}
	}

	getData() {
		this.fetchDataByUrl(this.url)
			.then(resp => {
				this.content = resp;
				this.addContentToMarkup();
			});
	}

	renderListItem(list) {
		let markup = '';

		list.forEach(item => markup += `<li class="recipe__item">${item}</li>`);

		return markup;
	}

	renderList(data) {
		let markup = '';
		if (data.ingridients1) {
			markup += `
				<div class="recipe__list-wrap">
					${data.title_ingridients1 && (
						`
							<div class="recipe__caption-wrap">
								<p class="recipe__caption">${data.title_ingridients1}</p>
							</div>
						`
					)}
					<ul class="recipe__list">
						${this.renderListItem(data.ingridients1)}
					</ul>
				</div>
			`;
		}
		if (data.ingridients2) {
			markup += `
				<div class="recipe__list-wrap">
					${data.title_ingridients2 && (
						`
							<div class="recipe__caption-wrap">
								<p class="recipe__caption">${data.title_ingridients2}</p>
							</div>
						`
					)}
					<ul class="recipe__list">
						${this.renderListItem(data.ingridients2)}
					</ul>
				</div>
			`;
		}
		return markup;
	}

	addContentToMarkup() {
		this.content.forEach((item, id) => {
			const $slide = $('<div></div>').attr({ class: 'recipe' });
			const markup = `
				<div class="recipe__content">
					<h3 class="recipe__title">${item.title}</h3>
					<div class="recipe__lists">
						${this.renderList(item)}
					</div>
					<div class="recipe__methods">
						<div class="recipe__caption-wrap">
							<p class="recipe__caption">Способ приготовления</p>
						</div>
						<div class="recipe__method">
							<p class="recipe__text">${item.cooking}</p>
							${item.title_decor && (
								`<p class="recipe__decor">${item.title_decor}</p>`
							)}
							${item.text_decor && (
								`<p class="recipe__text">${item.text_decor}</p>`
							)}
						</div>
					</div>
				</div>
				<div class="recipe__image" style="background-image: url('../..${item.image}')"></div>
				<p class="recipe__number">${id + 1}</p>
			`;
			$slide.html(markup);
			$slide.appendTo(this.$recipes);
		});
		this.initializeSlider();
	}

	initializeSlider() {
		this.$recipes.slick({
			dots: true,
			infinite: true,
			arrows: false
		});
		this.$sharing.attr({
			'data-image': 'https://horrorfood.woman.ru/img/share.jpg',
			'data-title': this.content[0].title,
			'data-url': `https://horrorfood.woman.ru/share_recipe/1/`
		});
	}
}

export default Recipes;



// WEBPACK FOOTER //
// ./app/scripts/recipes.js